import { render, staticRenderFns } from "./switch-field.vue?vue&type=template&id=3846d779&scoped=true&"
import script from "./switch-field.vue?vue&type=script&lang=js&"
export * from "./switch-field.vue?vue&type=script&lang=js&"
import style0 from "./switch-field.vue?vue&type=style&index=0&id=3846d779&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3846d779",
  null
  
)

export default component.exports